// ===========================================================================
// Cash — Constantes del módulo.
//
// EN DESARROLLO (source mock, sin contrato backend): DEV-ONLY, mismo gate que
// Membership — `yarn start` lo monta, `yarn build` no publica rutas ni
// sección del sidebar. Al pasar a productivo: quitar el gate acá y en
// navigationConfig.js, y registrar su moduleKey en roleRoutePermissions.js.
// ===========================================================================
export const CASH_ENABLED = process.env.NODE_ENV === "development";

export const K = "cash.dashboard";
export const PAGE_SIZE = 12;

export const CASH_COLORS = {
  ink: "#102A2E",
  inkSoft: "#52666A",
  teal: "#0F766E",
  tealDark: "#0A5A54",
  mint: "#D8F3EC",
  canvas: "#F4F7F6",
  paper: "#FFFFFF",
  line: "#D7E1DF",
  expense: "#C65D4B",
  beginning: "#73858A",
};

export const TYPE_OPTIONS = [
  { id: "Income", labelKey: `${K}.options.income`, label: "Income" },
  { id: "Expense", labelKey: `${K}.options.expense`, label: "Expense" },
  { id: "Beginning", labelKey: `${K}.options.beginning`, label: "Beginning" },
];

export const CATEGORY_OPTIONS = [
  { id: "Beginning Cash", labelKey: `${K}.categories.beginningCash`, label: "Beginning Cash" },
  { id: "Copayment", labelKey: `${K}.categories.copayment`, label: "Copayment" },
  { id: "Quest Diagnostic", labelKey: `${K}.categories.questDiagnostic`, label: "Quest Diagnostic" },
  { id: "Gas", labelKey: `${K}.categories.gas`, label: "Gas" },
  { id: "Medical Supplies", labelKey: `${K}.categories.medicalSupplies`, label: "Medical Supplies" },
  { id: "Office Supplies", labelKey: `${K}.categories.officeSupplies`, label: "Office Supplies" },
  { id: "Membership", labelKey: `${K}.categories.membership`, label: "Membership" },
  { id: "Repair and Mant", labelKey: `${K}.categories.repair`, label: "Repair and Mant" },
  { id: "Uber", labelKey: `${K}.categories.uber`, label: "Uber" },
];

export const PAYMENT_OPTIONS = [
  { id: "Credit Card", labelKey: `${K}.payments.creditCard`, label: "Credit Card" },
  { id: "Debit Card", labelKey: `${K}.payments.debitCard`, label: "Debit Card" },
  { id: "Cash", labelKey: `${K}.payments.cash`, label: "Cash" },
  { id: "Mobile Payments", labelKey: `${K}.payments.mobile`, label: "Mobile Payments" },
  { id: "Checks", labelKey: `${K}.payments.checks`, label: "Checks" },
];

export const FALLBACK_LOCATIONS = [
  { id: 1, label: "Fort Myers" },
  { id: 2, label: "Cape Coral" },
  { id: 3, label: "Lehigh Acres" },
  { id: 4, label: "Naples" },
];
